import __base_store from '@/store/__base_store'

export default __base_store({
	state: {
		model_name: 'inputs_size',
	},
})
